<div fxFlex fxLayout="column" fxLayoutAlign="space-between stretch" class="profile-card">
  <div class="tt-margin--bottom">
    @for (item of items; track item) {
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <forge-label-value>
        <div slot="label">{{item.Display}}</div>
        <span slot="value" class="profile-card--value">{{item.Value}}</span>
      </forge-label-value>
    </div>
    }
  </div>

  @if (passwordExpiring) {
  <forge-button variant="raised" theme="error" type="button" (click)="onChangePasswordClick()"
    class="tt-margin--bottom">
    Change password
  </forge-button>
  }

  @if (showERPProAppDownload) {
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="center center" class="tt-margin--bottom">
    <forge-button variant="tonal" type="button" (click)="onDownloadERPProAppClick()"
      telemetry="Download ERP Pro App Clicked">
      Download ERP Pro App
    </forge-button>
  </div>
  }

  @if (notifications > 0) {
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="center center" class="tt-margin--bottom">
    <forge-button variant="tonal" type="button" (click)="onViewClick()" telemetry="View Process Status">
      Notifications ({{notifications}})
    </forge-button>
  </div>
  }

  <div fxLayout="row" fxLayoutAlign="space-between start" class="profile-card--footer">
    <span fxFlex="auto"></span>
    <div>{{version}}</div>
  </div>
</div>